export const titleCase = (str: string) => str?.charAt(0).toLocaleUpperCase() + str?.slice(1).toLowerCase();
export const fmt = (str: string) => str.split(' ').map(titleCase).join(' ');
